import loadingStatusReducer from "./loadingStatus.duck";
import sessionReducer from "./session.duck";

const sdkReducer = {
    session: sessionReducer,
    loadingStatus: loadingStatusReducer,
};

export default sdkReducer;
